export class CustomerList {
    customerId: string;
    customerGroup: string;
    externalId: string;
    name: string;
    customerAddress: string;
    customerZipCode: string;
    customerCity: string;
    customerPhone: string;
    customerMobile: string;
    customerEmail: string;
    invoiceName: string;
    invoiceAddress: string;
    invoiceZipCode: string;
    invoiceCity: string;
    invoicePhone: string;
    invoiceMobile: string;
    invoiceEmail: string;
    customerNumber: string;
    propertyInfo: Array<PropertyInfo>;
    customerTags: Array<CustomerTags>
  }
  
  export class PropertyInfo {
    propertyNumber: string;
    propertyName: string;
    propertyLeaseAddress: string;
    propertyLeaseZipCode: string;
    propertyLeaseCity: string;
  }
  
  export class CustomerTags {
    customerTagId: string;
    name: string;
    color: string;
  }

  export class CustomerById {
    att: string;
    cvr: string;
    ean: string;
    // contactAddresse: ContactAddress[];
    customerId: string;
    deliveryId: string;
    contactId: string;
    customerGroup: string;
    customer: string;
    customerNumber:string;
    customerName: string;
    customerAddress: string;
    customerZipCode: string;
    customerCity:string;
    customerPhone: string;
    customerMobile: string;
    customerMail: string;
    externalId: string;
    invoiceName: string;
    invoiceAddress: string;
    invoiceZipCode: string;
    invoiceCity: string;
    invoicePhone: string;
    invoiceMobile: string;
    invoiceEmail: string;
    // addresses: DeliveryAddress[];
    propertyInfo: Array<any>;
  }
  
  export class ContactAddress {
    id: string;
    name: string;
    address: string;
    city: string;
    zipCode: string;
    phone: string;
    mobile: string;
    fax: string;
    email: string;
    ean: string;
    att: string;
    cvr: string;
  }

  export class DeliveryAddress {
    deliveryId: string;
    customerName: string;
    customerAddress: string;
    customerZipCode: string;
    customerCity: string;
    customerPhone: string;
    customerMobile: string;
    customerMail: string;
    ean?: string;
    att?: string;
  }

  export class EditCustomer {
    number: string;
    name: string;
    address: string;
    city: string;
    zipCode: string;
    phone: string;
    mobile: string;
    email: string;
    invoiceName: string;
    invoiceAddress: string;
    invoiceZipCode: string;
    invoiceCity: string;
    invoicePhone: string;
    invoiceMobile: string;
    invoiceMail: string;
    ean: string;
    att: string;
    cvr: string;
  }

  export class AddCustomer {
    companyId: string | null = null;
    number: string | null = null;
    customerName: string | null = null;
    customerAddress: string | null = null;
    customerZipCode: string | null = null;
    customerCity: string | null = null;
    customerTelephone: string | null = null;
    customerFax: string | null = null;
    customerEmail: string | null = null;
    customerMobile: string | null = null;
    invoiceName: string | null = null;
    invoiceAddress: string | null = null;
    invoiceZipCode: string | null = null;
    invoiceCity: string | null = null;
    invoiceTelephone: string | null = null;
    invoiceFax: string | null = null;
    invoiceEmail: string | null = null;
    invoiceMobile: string | null = null;
    customerGroupExternalId: string | null = null;
    cvr: string | null = null;
    att: string | null = null;
    ean: string | null = null;
    customerRemarks: string | null = null;
    externalId: string | null = null;
  }

  export class AddDeliveryAddress {
    customerId: string;
    name: string = '';
    address: string = '';
    zipCode: string = '';
    city: string = '';
    telephone: string = '';
    mobile: string = '';
    att: string = '';
    ean: string = '';
    email: string = '';
  }

  export class EditDeliveryAddress {
    name:string;
    address: string;
    zipCode: string;
    city: string;
    phone: string;
    mobile: string;
    email: string;
    ean: string;
    att: string;
  }

  export class AddContactAddress {
    customerId: string;
    name: string;
    address: string;
    zipCode: string;
    city: string;
    telephone: string;
    mobile: string;
    email: string;
    ean: string;
    att: string;
    cvr: string;
    fax: string;
  }

  export class EditContactAddress {
    name: string;
    address: string;
    zipCode: string;
    city: string;
    telephone: string;
    mobile: string;
    email: string;
    ean: string;
    att: string;
    cvr: string;
    fax: string;
  }
  
  export interface CustomerView {
    att:string;
    vat:string;
    ean:string;
    number: string;
    customer: CustomerViewAddress;
    invoice: CustomerViewAddress;
    delivery: CustomerViewAddress;
    contact: CustomerViewAddress;
    customerId: string;
    deliveryId: string;
    contactId: string;
  }
  
  export interface CustomerViewAddress {
    name: string;
    address: string;
    zip: string;
    city: string;
    email: string;
    phone: string;
    mobile: string;
    ean?: string;
    att?: string;
    fax?:string;
    cvr?:string;
  }
  
  export type CustomerViewTabs = 'customer' | 'invoice' | 'delivery' | 'contact';

  export class CustomerConvertor {
    public static viewAddressToEditDelivery = (customerViewAddress: CustomerViewAddress): EditDeliveryAddress => {
      const editDeliveryAddress = new EditDeliveryAddress();
      editDeliveryAddress.name = customerViewAddress.name;
      editDeliveryAddress.address = customerViewAddress.address;
      editDeliveryAddress.zipCode = customerViewAddress.zip;
      editDeliveryAddress.city = customerViewAddress.city;
      editDeliveryAddress.phone = customerViewAddress.phone;
      editDeliveryAddress.mobile = customerViewAddress.mobile;
      editDeliveryAddress.email = customerViewAddress.email;
      editDeliveryAddress.ean = customerViewAddress.ean || null;
      editDeliveryAddress.att = customerViewAddress.att || null;
    
      return editDeliveryAddress;
    }

    public static updateDeliveryAddress(customerById: CustomerById, deliveryId: string, editDeliveryAddress: EditDeliveryAddress): void {
      const deliveryAddressIndex = customerById['deliveries'].findIndex(address => address.deliveryId === deliveryId);
    
      if (deliveryAddressIndex !== -1) {
        const updatedDeliveryAddress: DeliveryAddress = {
          deliveryId: deliveryId,
          customerName: editDeliveryAddress.name,
          customerAddress: editDeliveryAddress.address,
          customerZipCode: editDeliveryAddress.zipCode,
          customerCity: editDeliveryAddress.city,
          customerPhone: editDeliveryAddress.phone,
          customerMobile: editDeliveryAddress.mobile,
          customerMail: editDeliveryAddress.email,
          ean: editDeliveryAddress.ean,
          att: editDeliveryAddress.att
        };
    
        customerById['deliveries'].splice(deliveryAddressIndex, 1, updatedDeliveryAddress);
      } else {
        console.error('Delivery address with the specified deliveryId not found.');
      }
    }

    public static viewAddressToContactAddress(customerViewAddress: CustomerViewAddress): EditContactAddress {
      const editContactAddress: EditContactAddress = {
        name: customerViewAddress.name,
        address: customerViewAddress.address,
        zipCode: customerViewAddress.zip,
        city: customerViewAddress.city,
        telephone: customerViewAddress.phone,
        mobile: customerViewAddress.mobile,
        email: customerViewAddress.email,
        ean: customerViewAddress.ean || null,
        att: customerViewAddress.att || null,
        cvr: customerViewAddress.cvr || null,
        fax: ''
      };
    
      return editContactAddress;
    }

    public static updateContactAddress(customerById: CustomerById, contactId: string, editContactAddress: EditContactAddress): void {
      const contactAddressIndex = customerById['contact'].findIndex(contact => contact.id === contactId);
    
      if (contactAddressIndex !== -1) {
        const updatedContactAddress: ContactAddress = {
          id: contactId,
          name: editContactAddress.name,
          address: editContactAddress.address,
          city: editContactAddress.city,
          zipCode: editContactAddress.zipCode,
          phone: editContactAddress.telephone,
          mobile: editContactAddress.mobile,
          fax: editContactAddress.fax,
          email: editContactAddress.email,
          ean: editContactAddress.ean,
          att: editContactAddress.att,
          cvr: editContactAddress.cvr
        };
    
        customerById['contacts'].splice(contactAddressIndex, 1, updatedContactAddress);
      } else {
        console.error('Contact address with the specified contactId not found.');
      }
    }

    public static viewAddressToAddDeliveryAddress(customerViewAddress: CustomerViewAddress, customerId: string): AddDeliveryAddress {
      const addDeliveryAddress: AddDeliveryAddress = {
        customerId: customerId,
        name: customerViewAddress.name,
        address: customerViewAddress.address,
        zipCode: customerViewAddress.zip,
        city: customerViewAddress.city,
        telephone: customerViewAddress.phone,
        mobile: customerViewAddress.mobile,
        att: customerViewAddress.att || null,
        ean: customerViewAddress.ean || null,
        email: customerViewAddress.email
      };
    
      return addDeliveryAddress;
    }

    public static viewAddressToAddContactAddress(customerViewAddress: CustomerViewAddress, customerId: string): AddContactAddress {
      const addContactAddress: AddContactAddress = {
        customerId: customerId,
        name: customerViewAddress.name,
        address: customerViewAddress.address,
        zipCode: customerViewAddress.zip,
        city: customerViewAddress.city,
        telephone: customerViewAddress.phone,
        mobile: customerViewAddress.mobile,
        email: customerViewAddress.email,
        ean: customerViewAddress.ean || null,
        att: customerViewAddress.att || null,
        cvr: customerViewAddress.cvr || null,
        fax: null
      };
    
      return addContactAddress;
    }

    public static addDeliveryToCustomer(customerById: CustomerById, customerViewAddress: CustomerViewAddress, deliveryId: string): void {
      const newDeliveryAddress: DeliveryAddress = {
        deliveryId: deliveryId,
        customerName: customerViewAddress.name,
        customerAddress: customerViewAddress.address,
        customerZipCode: customerViewAddress.zip,
        customerCity: customerViewAddress.city,
        customerPhone: customerViewAddress.phone,
        customerMobile: customerViewAddress.mobile,
        customerMail: customerViewAddress.email,
        ean: customerViewAddress.ean || null,
        att: customerViewAddress.att || null
      };
    
      customerById['deliveries'].push(newDeliveryAddress);
    }

    public static addContactToCustomer(customerById: CustomerById, customerViewAddress: CustomerViewAddress, contactId: string): void {
      const newContactAddress: ContactAddress = {
        id: contactId,
        name: customerViewAddress.name,
        address: customerViewAddress.address,
        city: customerViewAddress.city,
        zipCode: customerViewAddress.zip,
        phone: customerViewAddress.phone,
        mobile: customerViewAddress.mobile,
        fax: null,
        email: customerViewAddress.email,
        ean: customerViewAddress.ean || null,
        att: customerViewAddress.att || null,
        cvr: customerViewAddress.cvr || null
      };
    
      customerById['contacts'].push(newContactAddress);
    }

    public static customerViewToEditCustomer(customerView: CustomerView): EditCustomer {
      const editCustomer: EditCustomer = {
        number: customerView.number,
        name: customerView.customer.name,
        address: customerView.customer.address,
        city: customerView.customer.city,
        zipCode: customerView.customer.zip,
        phone: customerView.customer.phone,
        mobile: customerView.customer.mobile,
        email: customerView.customer.email,
        invoiceName: customerView.invoice.name,
        invoiceAddress: customerView.invoice.address,
        invoiceZipCode: customerView.invoice.zip,
        invoiceCity: customerView.invoice.city,
        invoicePhone: customerView.invoice.phone,
        invoiceMobile: customerView.invoice.mobile,
        invoiceMail: customerView.invoice.email,
        ean: customerView.ean,
        att: customerView.att,
        cvr: customerView.vat
      };
    
      return editCustomer;
    }
  }